import { useState } from "react";
// Generated by Copilot- Start - 2026-04-01 20:31:38
import { useApiPaths } from '@directv-digital/dds.server.application-context';
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvGrid from "@directv-digital/dds.ui.dtv-grid";
import DtvText from "@directv-digital/dds.ui.dtv-text";
import DtvTheme, { colorPalette } from "@directv-digital/dds.ui.dtv-theme";
import TextFieldDropdown from "@directv-digital/dds.ui.text-field-dropdown";
import DtvButton from "@directv-digital/dds.ui.dtv-button";

import {
  channelLookupByDma,
  channelLookupByZipcode,
  channelLookupByCallSign
} from "src/apis/localChannelsLookup";
import  DtvTextField  from "@directv-digital/dds.ui.dtv-text-field";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

const styles = {
  headingStyle: {
    marginTop: "68px",
    marginBottom: "32px",
    color: colorPalette.jet.main,
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      marginTop: "64px",
      marginBottom: "20px"
    }
  },
  subheading1Style: {
    marginBottom: "32px",
    color: colorPalette.jet.main,
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      marginBottom: "20px"
    }
  },
  body1Style: {
    marginBottom: "32px",
    color: colorPalette.jet.main
  },
  body2Style: {
    marginBottom: "48px",
    color: colorPalette.jet.main,
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      marginBottom: "32px"
    }
  },
  subheading2Style: {
    marginBottom: "20px",
    color: colorPalette.jet.main
  },
  body3Style: {
    marginBottom: "32px",
    color: colorPalette.jet.main,
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      marginBottom: "20px"
    }
  },
  tableCell: {
    width: "200px",
    maxWidth: "200px",
    textOverflow: "unset",
    borderStyle: "border-box",
    overflowWrap: "break-word",
    border: "solid 0.2px"
  },
  boxstyle: {
    width: "100%",
    display: "inline-flex",
    marginBottom: "32px",
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      display: "block"
    }
  },
  DMABoxStyle: {
    marginBottom: 0
  },
  btnStyle: {
    marginLeft: "8px",
    width: "35%",
    height: "50px",
    marginTop: "3.5px",
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      marginLeft: "0",
      width: "100%",
      marginBottom: "0px"
    }
  },
  borderStyle: {
    border: "solid 0.2px"
  },
  tableStyle: {
    width: "95%",
    margin: "0 auto 100px auto",
    border: "solid 0.2px",
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      margin: "0 10px 100px 10px"
    }
  },
  gridStyle: {
    margin: "0 auto",
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      width: "auto",
      margin: "0 20px"
    }
  },
  textFieldStyle: {
    // marginBottom: "32px",
    height: "auto",
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      marginBottom: "20px"
    }
  },
  resultTextMargin: {
    marginLeft: "40px",
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      marginLeft: "20px"
    }
  }
};

export function LocalChannelsLookupPage(props) {
  // const [hasErrorDropdownLightMode, setHasErrorDropdownLightMode] =
  useState(false);
  // Generated by Copilot- End - 2026-04-01 20:31:38
  const apiPaths = useApiPaths();
  const [dma, setdma] = useState(null);
  const [zipcode, setZipCode] = useState(null);
  const [stationCallSign, setStationCallSign] = useState(null);
  const [lookupResults, setLookupResults] = useState(null);
  const {
    heading,
    subheading1,
    body1,
    body2,
    subheading2,
    body3,
    submitBtnLabel,
    zipcodeTextLabel,
    stationTextLabel,
    dmaTableHeading,
    stateTableHeading,
    zipcodeTableHeading,
    countyTableHeading,
    stationTableheading,
    channelTableHeading,
    networkTableHeading,
    originatingDmaTableHeading,
    resultHeading,
    noResultText
  } = props?.generalLabels ?? {};
  const { id, variant, mode, label, isDisabled, options } =
    props?.dma ?? {};

  const handleClick = event => {
    const rootURL = apiPaths?.API_CHANNEL_LOOKUP ? apiPaths?.API_CHANNEL_LOOKUP : "/xapi/beamlocalchannellookupms/v1/channels/";
    event.stopPropagation();

    switch (event.target.id) {
      case "dma-btn":
        if (dma) {
          channelLookupByDma(rootURL, dma).then(res => {
            setLookupResults(res);
          });
        }
        break;
      case "zipcode-btn":
        if (zipcode && zipcode.length === 5) {
          channelLookupByZipcode(rootURL, zipcode).then(res => {
            setLookupResults(res);
          });
        }
        break;
      case "call-sign-btn":
        if (stationCallSign) {
          channelLookupByCallSign(rootURL, stationCallSign).then(res => {
            setLookupResults(res);
          });
        }
        break;
      default:
        break;
    }
  };
  const textFieldDropdownOnLight = {
    id,
    varaint: variant,
    mode,
    label,
    isDisabled,
    // error,
    // errorMessage,
    options
  };
  const zipcodeTextFieldOnLight = {
    id: "text field on light mode",
    type: "zipcode",
    mode: "light",
    label: zipcodeTextLabel,
    autoComplete: "off",
    hasIcon: true,
    error: false,
    // errorMessage: "The zip code you entered is invalid. Please try again.",
    isVisaCard: false,

    disabled: false
  };
  const stationCallSignTextFieldOnLight = {
    id: "text field on light mode",
    mode: "light",
    label: stationTextLabel,
    autoComplete: "off",
    hasIcon: true,
    isVisaCard: false,
    disabled: false
  };

  const channelLookupTable =
    lookupResults && lookupResults.length > 0 ? (
      <DtvBox
        sx={{
          width: "100%"
        }}
      >
        <DtvText
          component="div"
          content={resultHeading}
          variant="subhead1medium"
          sx={{
 ...styles.subheading1Style,
...styles.resultTextMargin
}}
        />
        <TableContainer component="div">
          <Table sx={{ ...styles.tableStyle }}>
            <TableHead>
              <TableRow sx={{ ...styles.borderStyle }}>
                <TableCell sx={{ ...styles.borderStyle }}>{dmaTableHeading}</TableCell>
                <TableCell sx={{ ...styles.borderStyle }}>{stateTableHeading}</TableCell>
                <TableCell sx={{ ...styles.borderStyle }}>{zipcodeTableHeading}</TableCell>
                <TableCell sx={{ ...styles.borderStyle }}>{countyTableHeading}</TableCell>
                <TableCell sx={{ ...styles.borderStyle }}>{stationTableheading}</TableCell>
                <TableCell sx={{ ...styles.borderStyle }}>{channelTableHeading}</TableCell>
                <TableCell sx={{ ...styles.borderStyle }}>{networkTableHeading}</TableCell>
                <TableCell sx={{ ...styles.borderStyle }}>{originatingDmaTableHeading}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {lookupResults.map((result, index) => (
                  <TableRow key={index} sx={{ ...styles.borderStyle }}>
                    <TableCell sx={{ ...styles.borderStyle }}>{result?.yourDMADescription}</TableCell>
                    <TableCell sx={{ ...styles.borderStyle }}>{result?.state}</TableCell>
                    <TableCell sx={{ ...styles.tableCell }}>
                      {result?.zipCode.join(", ")}
                    </TableCell>
                    <TableCell sx={{ ...styles.borderStyle }}>{result?.countyName}</TableCell>
                    <TableCell sx={{ ...styles.borderStyle }}>{result?.svChannelCallSign}</TableCell>
                    <TableCell sx={{ ...styles.borderStyle }}>{result?.svChannelNumber}</TableCell>
                    <TableCell sx={{ ...styles.borderStyle }}>{result?.svNetworkCallSign}</TableCell>
                    <TableCell sx={{ ...styles.borderStyle }}>{result?.orginatingDMADescription}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DtvBox>
    ) : null;

  return (
    <>
      <DtvGrid
        container
        item
        alignItems="center"
        direction={"column"}
        id="local_channel_lookup_page"
        justifyContent="center"
        lg={6}
        md={6}
        sm={6}
        sx={{ ...styles.gridStyle }}
        xs={12}
      >
        <DtvBox
          sx={{
            textAlign: "center"
          }}
        >
          <DtvText
            component="div"
            content={heading}
            sx={{ ...styles.headingStyle }}
            variant="body2"
          />
          <DtvText
            component="h1"
            content={subheading1}
            sx={{ ...styles.subheading1Style }}
            variant="subhead1medium"
          />
          <DtvText
            component="div"
            content={body1}
            sx={{ ...styles.body1Style }}
            variant="body1"
          />
          <DtvText
            component="div"
            content={body2}
            sx={{ ...styles.body2Style }}
            variant="body1"
          />
          <DtvText
            component="div"
            content={subheading2}
            sx={{ ...styles.subheading2Style }}
            variant="subhead2medium"
          />
          <DtvText
            component="div"
            content={body3}
            sx={{ ...styles.body3Style }}
            variant="body1"
          />
        </DtvBox>
        <DtvBox
          sx={{ ...styles.boxstyle }}
          onClick={event => {
            handleClick(event);
          }}
        >
          <TextFieldDropdown
            id="dma-dropdown"
            {...textFieldDropdownOnLight}
            // error={hasErrorDropdownLightMode}
            sx={{ ...styles.textFieldStyle }}
            gridColumns={{
              xs: 12,
              sm: 8,
              md: 8,
              lg: 8,
              xl: 8
            }}
            onChange={event => {
              setdma(event.target.value);
            }}
          />
          <DtvButton
            id="dma-btn"
            label={submitBtnLabel}
            sx={{ ...styles.btnStyle }}
            variant="uxprimary"
          />
        </DtvBox>
        <DtvBox
          sx={{ ...styles.boxstyle }}
          onClick={event => {
            handleClick(event);
          }}
        >
          <DtvTextField
            id="zipcode-textfield"
            {...zipcodeTextFieldOnLight}
            // error={hasErrorDropdownLightMode}
            sx={{ ...styles.textFieldStyle }}
            gridColumns={{
              xs: 12,
              sm: 8,
              md: 8,
              lg: 8,
              xl: 8
            }}
            onChange={event => {
              setZipCode(event.target.value);
            }}
          />
          <DtvButton
            id="zipcode-btn"
            label={submitBtnLabel}
            sx={{ ...styles.btnStyle }}
            variant="uxprimary"
          />
        </DtvBox>
        <DtvBox
          sx={{
 ...styles.boxstyle,
...styles.DMABoxStyle
}}
          onClick={event => {
            handleClick(event);
          }}
        >
          <DtvTextField
            {...stationCallSignTextFieldOnLight}
            // error={hasErrorStationCallSign}
            sx={{ ...styles.textFieldStyle }}
            gridColumns={{
              xs: 12,
              sm: 8,
              md: 8,
              lg: 8,
              xl: 8
            }}
            onChange={event => {
              setStationCallSign(event.target.value);
            }}
          />
          <DtvButton
            id="call-sign-btn"
            label={submitBtnLabel}
            sx={{ ...styles.btnStyle }}
            variant="uxprimary"
          />
        </DtvBox>
      </DtvGrid>
      {lookupResults ?
        channelLookupTable ?
          channelLookupTable :
          noResultText :
        null}
    </>
  );
}
